import React, { useState } from 'react';
import { CheckIcon, LockIcon } from 'lucide-react';
import { ACCOUNT_PROFILE } from '../../data/account';
const fieldClass = 'w-full border border-white/10 bg-ink-900 px-4 py-3.5 text-sm text-white placeholder:text-white/30 focus:border-pink-500 focus:outline-none';
const labelClass = 'block text-[10px] font-bold uppercase tracking-[0.2em] text-white/45';
export function ProfileDataTab() {
  const [saved, setSaved] = useState(false);
  return <form onSubmit={e => {
    e.preventDefault();
    setSaved(true);
    window.setTimeout(() => setSaved(false), 2200);
  }} className="border border-white/10 bg-ink-800 p-6 sm:p-8" data-id="element-113" data-mp="mxkfbt013ywz">
      <h2 className="font-display text-2xl uppercase tracking-wide text-white" data-id="element-114" data-mp="873eaarb3b0m">
        Mis datos
      </h2>
      <p className="mt-1.5 text-sm text-white/45" data-id="element-115" data-mp="15mr49xrf1mr8">
        Usamos estos datos para tus envíos y comprobantes.
      </p>

      <div className="mt-8 grid gap-5 sm:grid-cols-2" data-id="element-116" data-mp="10ug1mn5ajmuz">
        <div data-id="element-117" data-mp="16jumao4w2nna">
          <label className={labelClass} htmlFor="acc-first" data-id="element-118" data-mp="16jb4r8j5i19s">
            Nombre
          </label>
          <input id="acc-first" defaultValue={ACCOUNT_PROFILE.firstName} autoComplete="given-name" className={`mt-2 ${fieldClass}`} data-id="element-119" data-mp="1bio06ho38gnz" />
        </div>
        <div data-id="element-120" data-mp="11sky7ryznsdi">
          <label className={labelClass} htmlFor="acc-last" data-id="element-121" data-mp="11s2uka9zybvk">
            Apellido
          </label>
          <input id="acc-last" defaultValue={ACCOUNT_PROFILE.lastName} autoComplete="family-name" className={`mt-2 ${fieldClass}`} data-id="element-122" data-mp="nsa8is9f0jtx" />
        </div>

        <div className="sm:col-span-2" data-id="element-123" data-mp="dw775ome0p81">
          <label className={labelClass} htmlFor="acc-email" data-id="element-124" data-mp="dx9ujmki49j7">
            Email
          </label>
          <div className="relative mt-2" data-id="element-125" data-mp="iwctcp9w1jiq">
            <input id="acc-email" readOnly value={ACCOUNT_PROFILE.email} className={`${fieldClass} cursor-not-allowed pr-11 text-white/40`} data-id="element-126" data-mp="288x1g7go40fy" />
            <LockIcon className="absolute right-4 top-1/2 h-4 w-4 -translate-y-1/2 text-white/25" data-id="element-127" data-mp="2bs5l3jwmk1in" />
          </div>
          <p className="mt-2 text-xs text-white/30" data-id="element-128" data-mp="26r82553sj3g3">
            Escribinos a hola@zadar.uy para cambiar tu email.
          </p>
        </div>

        <div data-id="element-129" data-mp="1wtv3hehqi4om">
          <label className={labelClass} htmlFor="acc-phone" data-id="element-130" data-mp="1wu3jhf95lq41">
            Teléfono
          </label>
          <input id="acc-phone" type="tel" defaultValue={ACCOUNT_PROFILE.phone} autoComplete="tel" className={`mt-2 ${fieldClass}`} data-id="element-131" data-mp="2uhc5rcgzb373" />
        </div>
        <div data-id="element-132" data-mp="2kr0rox3kzdmh">
          <label className={labelClass} htmlFor="acc-birth" data-id="element-133" data-mp="2kqhl2cjdsbnr">
            Fecha de nacimiento
          </label>
          <input id="acc-birth" type="date" defaultValue={ACCOUNT_PROFILE.birthDate} className={`mt-2 ${fieldClass}`} data-id="element-134" data-mp="2fs6afzl9hx4h" />
        </div>
      </div>

      <button type="submit" className="mt-8 w-full bg-pink-500 py-4 text-xs font-bold uppercase tracking-[0.2em] text-white transition-colors hover:bg-pink-600" data-id="element-135" data-mp="38ftp6xzuptj7">
        Guardar cambios
      </button>

      {saved && <p role="status" className="mt-4 flex items-center justify-center gap-2 text-xs text-teal-400" data-id="element-136" data-mp="3pqyym7u07sf4">
          <CheckIcon className="h-4 w-4" data-id="element-137" data-mp="3uqldsmte7iqk" /> Datos actualizados
        </p>}
    </form>;
}